import { withStyles } from '@material-ui/core';
import React from 'react';
import { Button } from '../Button';

const CustomButton = withStyles(() => ({
  root: {
    textTransform: 'none',
    fontSize: '13px',
  },
}))(Button);

export const FilterClearButton: React.FC<{ onClick: () => void; isActive?: boolean }> = ({
  onClick,
  isActive,
  children,
}) => (
  <CustomButton variant='text' color={'primary'} onClick={onClick} disabled={!isActive}>
    {children}
  </CustomButton>
);
